import React, { useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import { observable } from 'mobx';
import { swiperOptions } from './swiper-options';
import { noop } from '@xfe-team/utils/src/common-util';

class BaseSwiperStore {
  @observable swiperOptions = swiperOptions.default;

  @observable activeIndex = 0;
  @observable size = 0;
  onSlideChange = noop;

  nativeSwiper = null;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  goNext = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slideNext();
  };

  goPrev = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slidePrev();
  };

  onChange = activeIndex => {
    this.activeIndex = activeIndex;
  };

  isDisabled() {
    return this.size < 2;
  }

  use({ children }) {
    this.size = React.Children.count(children);

    const swiperRef = (this.swiperRef = useRef());
    this.onResize = debounce(() => {
      swiperRef.current?.swiper.update();
      console.log('this.onResize');
    }, 500);

    useEffect(() => {
      this.nativeSwiper = this.swiperRef.current?.swiper;
    }, []);

    useEffect(
      () => {
        const onResize = this.onResize;
        window.addEventListener('resize', onResize);
        return () => {
          window.removeEventListener('resize', onResize);
        };
      },
      [this.onResize]
    );

    useEffect(() => {
      const swiper = this.swiperRef.current.swiper;
      const context = this;
      swiper.on('slideChange', function() {
        context.onSlideChange(swiper.realIndex);
        context.activeIndex = swiper.realIndex;
      });
      return () => {};
    }, []);

    useEffect(
      () => {
        if (this.swiperRef.current.swiper?.realIndex !== this.activeIndex) {
          const swiper = this.swiperRef.current.swiper;
          swiper.slideToLoop(this.activeIndex);
          // this.onSlideChange(this.activeIndex);
        }
      },
      [this.activeIndex]
    );
  }
}

export default BaseSwiperStore;
